import React from 'react';
import { injectIntl } from 'react-intl';
import { Card, Label } from 'semantic-ui-react';
import styles from './LinkCard.css';
import locale from '../locale';

const LinkCard = injectIntl(({ intl: { formatMessage }, header, unreadMessagesCount }) => {
  return (
    <Card fluid>
      <Card.Content>
        <Card.Header>{header}</Card.Header>
        <Card.Description>
          <ul className={styles.quickLinks}>
            <a href="/dashboard/conversations">
              <li>
                {formatMessage(locale.messages)}
                {unreadMessagesCount >0 && <Label circular>{unreadMessagesCount}</Label>}
              </li>
            </a>
            <a href="/dashboard/payment-preferences">
              <li>{formatMessage(locale.paymentPrefs)}</li>
            </a>
            <a href="/dashboard/my-events">
              <li>{formatMessage(locale.manageEditEvent)}</li>
            </a>
            <a href="https://www.universe-payouts.com/" target="_blank noopener noreferrer">
              <li>{formatMessage(locale.universePayouts)}</li>
            </a>
            <a href="/dashboard/organizations">
              <li>{formatMessage(locale.usersPerms)}</li>
            </a>
          </ul>
        </Card.Description>
      </Card.Content>
    </Card>
  );
});

export default LinkCard;
